import { getBasicComponent } from '@/components/templates/common';
/**
 * 查找活动组件
 * @param {} componentId
 * @param {*} actComponentLib
 * @returns
 */
function findActComponent(componentId, actComponentLib) {
  return actComponentLib[componentId];
}
/**
 * 是否基础组件，基础组件id范围 2000~3000
 * @param {*} componentConfig
 * @returns Boolean
 */
export function isBasicComponent(componentConfig) {
  return (
    componentConfig.componentTypeId > 2000 &&
    componentConfig.componentTypeId < 3000
  );
}
/**
 * 是否流式布局组件
 * @param {*} compData 组件数据
 * @returns Boolean
 */
export function isFlowComponent(compData) {
  return compData.layoutType === 'flow';
}

/**
 * 是否右上角按钮
 * @param {*} compData 组件数据
 * @returns
 */
export function isPinnedBtnComponent(compData) {
  return [2001, 2002].includes(compData.componentTypeId);
}
/**
 * 生成基础组件对象
 * @param {*} compData 基础组件数据
 * @param {*} actData 活动数据
 * @returns 基础组件对象
 */
export function defaultBasicComponentBuilder(compData, componentRef, actData) {
  const { componentDetail = {}, ...fields } = compData;
  return {
    ...compData,
    props: {
      ...fields,
      ...componentDetail,
      actData
    },
    component: componentRef
  };
}

function defaultActComponentBuilder(compData, actComponentRef) {
  const { componentDetail = {}, ...fields } = compData;
  return {
    ...compData,
    props: {
      ...fields,
      ...componentDetail
    },
    component: actComponentRef
  };
}
function existComponents(source = [], target, compData) {
  let index = source.findIndex(
    item => item.componentTypeId == compData.componentTypeId
  );
  if (index >= 0) {
    source.splice(index, 1, target);
  } else {
    source.push(target);
  }
  return source;
}
export const resolveComponents = (
  componentsMetaData,
  { actData, actComponentLib, basicComponentBuilder, actComponentBuilder }
) => {
  let flowComponentObjs = [];
  let positionComponentObjs = [];
  componentsMetaData &&
    componentsMetaData.forEach(compData => {
      // 基础组件
      if (isBasicComponent(compData)) {
        let componentRef;
        try {
          componentRef = getBasicComponent(compData.componentTypeId);
        } catch (err) {
          console.error(err);
        }
        let basicComponentObj;
        if (basicComponentBuilder) {
          basicComponentObj = basicComponentBuilder(compData, componentRef);
        } else if (actData) {
          basicComponentObj = defaultBasicComponentBuilder(
            compData,
            componentRef,
            actData
          );
        } else {
          console.log('必须传入 actData 或者 basicComponentBuilder');
        }
        if (isFlowComponent(compData)) {
          flowComponentObjs.push(basicComponentObj);
          return;
        }
        positionComponentObjs.push(basicComponentObj);
      }
      // 活动组件
      if (!actComponentLib) {
        console.log('必须传入 actComponentLib');
        return;
      }
      const actComponentRef = findActComponent(
        compData.componentTypeId,
        actComponentLib
      );
      if (!actComponentRef) {
        console.error(`不支持的活动组件: ${compData.componentTypeId}`);
        return;
      }
      let actComponentObj;
      if (actComponentBuilder) {
        actComponentObj = actComponentBuilder(compData, actComponentRef);
      } else {
        actComponentObj = defaultActComponentBuilder(compData, actComponentRef);
      }
      if (isFlowComponent(compData)) {
        flowComponentObjs = existComponents(
          flowComponentObjs,
          actComponentObj,
          compData
        );
        return;
      }
      positionComponentObjs = existComponents(
        positionComponentObjs,
        actComponentObj,
        compData
      );
    });
  return [flowComponentObjs, positionComponentObjs];
};
